import request from '../utils/request.js'

export default {
	//修改密码
	uPwd(params) {
		return request.post(`user/edit_password`, params).then(res => res.data);
	},
	//获取用户组列表
	getUserGroupList(params) {
		return request.get(`user_group/lists`, {params}).then(res => res.data);
	},

	//获取用户组权限列表
	getUserGroup(params) {
		return request.post(`user_group/get_auth_tree`, params).then(res => res.data);
	},
	//编辑用户组权限
	editUserGroup(params) {
		return request.post(`user_group/add`, params).then(res => res.data);
	},
	//删除橘色
	delUserGroup(params) {
		return request.post(`user_group/del`, params).then(res => res.data);
	},
	//获取管理员列表
	getUserList(params){
		return request.get(`user/lists`, {params}).then(res => res.data);
	},
	//删除管理员
	delUser(params){
		return request.post(`user/del`, params).then(res => res.data);
	},
	//添加/编辑管理员
	editUser(params){
		return request.post(`user/add`, params).then(res => res.data);
	},
	//获取当前用户权限
	getUserPermissions(params){
		return request.get(`user/get_permissions`, {params}).then(res => res.data);
	},
	//获取当前用户信息
	getUserInfo(params){
		return request.get(`user/info`, {params}).then(res => res.data);
	}
}


// WEBPACK FOOTER //
// ./src/api/user.js